module.exports = __webpack_public_path__ + "static/media/Project-china.97ca88c4.svg";